import React from 'react';

import { createClassName } from 'utils/createClassName';

import './homePageLayoutStyles.scss';

type Props = {
  logo: React.ReactNode;
  accountControls: React.ReactNode;
};

export const HomePageLayoutComponent: React.FC<Props> = (props) => {
  const { logo, children, accountControls } = props;

  const createHomePageLayoutClassName = createClassName('homePageLayout');

  const wrapperClassName = createHomePageLayoutClassName('wrapper');

  const logoSlotClassName = createHomePageLayoutClassName('logoSlot');

  const accountControlsSlotBlockClassName = createHomePageLayoutClassName(
    'accountControlsSlot'
  );

  const cardsSlotClassName = createHomePageLayoutClassName('cardsSlot');

  const contentClassName = createHomePageLayoutClassName('content');

  return (
    <div className={wrapperClassName}>
      <div className={logoSlotClassName}>{logo}</div>
      <div className={accountControlsSlotBlockClassName}>{accountControls}</div>
      <div className={contentClassName}>
        <div className={cardsSlotClassName}>{children}</div>
      </div>
    </div>
  );
};
